import { render, staticRenderFns } from "./goodsinfo.vue?vue&type=template&id=1c69871e&scoped=true"
import script from "./goodsinfo.vue?vue&type=script&lang=js"
export * from "./goodsinfo.vue?vue&type=script&lang=js"
import style0 from "./goodsinfo.vue?vue&type=style&index=0&id=1c69871e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c69871e",
  null
  
)

export default component.exports